import gql from 'graphql-tag';

export const DEAL_BUILDER_QUOTE_FRAGMENT = gql`
  fragment DealBuilderQuoteFields on Quote {
    quoteId
    attributes {
      key
      description
      value
    }
    feesTotal
    fees {
      type
      amount
      isTaxable
      amountType
      description
      equipmentId
      isFromCommonRules
      price {
        total
        markup
        netPrice
        discount
        salesTax
        markupType
        retailPrice
        discountType
        salesTaxType
        wholesalePrice
      }
    }
    aftermarketProducts {
      type
      description
      cost
      equipmentId
    }
    aftermarketProductsTotal
    rebates {
      description
      amount
      equipmentId
    }
    rebatesTotal
    cashBackAmounts {
      description
      amount
      equipmentId
    }
    cashBackAmountsTotal
    tradeValueNet
    tradeValueGross
    tradeValueOwed
    equipmentTradeIns {
      equipmentId
      externalId
      vin
      stockNumber
      tradeInDetails {
        tradeValue
        tradeAmountOwed
        tradeOtherCharges
      }
    }
    equipment {
      equipmentId
      externalId
      vin
      stockNumber
      cost
      attributes {
        key
        description
        value
      }
      price {
        total
        markup
        netPrice
        discount
        salesTax
        markupType
        retailPrice
        discountType
        salesTaxType
        wholesalePrice
      }
    }
    equipmentSubtotal
    deposit {
      type
      value
      notes
    }
    createdDateTime
    modifiedDateTime
  }
`;
